import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleAccessService } from 'src/app/core/guards/role-access.service';
import { MvRouteGuardService } from 'src/app/core/services/msal/guards/mv-route-guard.service';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { KpiInsightsConfigComponent } from '../kpi-insights-config/kpi-insights-config.component';
import { PredictiveFailureConfigComponent } from '../predictive-failure-config/predictive-failure-config.component';
import { LandingPageComponent } from './landing-page.component';
import { AccessKpiConfigService } from 'src/app/core/guards/access-kpi-config.service';
import { AccessPredictiveConfigService } from 'src/app/core/guards/access-predictive-config.service';
import { EwbConfigComponent} from '../ewb-configuration/ewb-config.component';
import { EwbConfigService } from 'src/app/core/guards/access-ewb-config.service';

const routes: Routes = [
  {
    path: '',
    component: LandingPageComponent,
    canActivate: [MvRouteGuardService],
    children: [
      {
        path: '',
        component: DashboardComponent,
        canActivate: [MvRouteGuardService],
        resolve: {canAccess: RoleAccessService},
        data: { title: 'IA Config - Dashboard'}
      },
      {
        path: 'kpi/:kpiConfiguration',
        component: KpiInsightsConfigComponent,
        canActivate: [MvRouteGuardService, AccessKpiConfigService],
        data: { title: 'IA Config - Insights based on KPIs Configuration'}
      },
      {
        path: 'predictive/:predictiveConfiguration',
        component: PredictiveFailureConfigComponent,
        canActivate: [MvRouteGuardService, AccessPredictiveConfigService],
        data: { title: 'IA Config - Predictive Failure & Custom Insight Category Configuration'}
      },
      {
        path: 'ewbconfiguration/ewb-anomaly-detection',
        component: EwbConfigComponent,
        canActivate: [MvRouteGuardService, EwbConfigService],
        data: { title: 'IA Config - EWB Configuration'}
      }
    ]
  }
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class LandingPageRoutes{}
